module.exports = "/_next/static/media/megaphone-cover2.1daf3ca9.jpg";